import React from "react";
import { useQueryClient } from "react-query";
import { candidateAPI } from "../../api/candidate";
import { showErrorToastMsg } from "../../generic-components/messages/CvpToastMessages";
import { useConsentsForCandidate } from "../../user/useConsentsForCandidate";
import { useLocStore } from "../../localization";
import { LocContext } from "../../localization/LocContext";
import { CvpButton } from "../../generic-components/buttons/CvpButton";
import { Consent5000 } from "../common/Consent5000";
import { getFormSubmitErrorMessage } from "../forms/formUtils/handleFormSubmitError";
import { CvpDialog } from "./CvpDialog";
import { useCvpQueryClient } from "../../api/queryClient";

interface Consent5000DialogProps {
  setOpenDeleteDialog: (open: boolean) => void;
}

export const Consent5000Dialog = (props: Consent5000DialogProps) => {
  const { setOpenDeleteDialog } = props;
  const L = useLocStore(LocContext.GENERAL);
  const { consent5000 } = useConsentsForCandidate();

  const cvpQueryClient = useCvpQueryClient();
  const type = 5000;

  const onConsentAccept = async () => {
    try {
      await candidateAPI.startConsentForCandidate({ consentType: type });
      cvpQueryClient.invalidateQueries();
    } catch (error) {
      const withCorrelationId = getFormSubmitErrorMessage(error);
      showErrorToastMsg(withCorrelationId);
    }
  };

  const onConsentDecline = async () => {
    if (!consent5000.consented) return;
    try {
      await candidateAPI.endConsentForCandidate({ consentType: type });
      cvpQueryClient.invalidateQueries();
    } catch (error) {
      const withCorrelationId = getFormSubmitErrorMessage(error);
      showErrorToastMsg(withCorrelationId);
    }
  };

  return (
    <CvpDialog
      visible
      headerElement={
        <h2 className="cvp-h2">
          {L.id("f984cb8e1bf3").loc(
            "Generell samtykkeerklæring for behandling av personopplysninger"
          )}
        </h2>
      }
      footerContent={
        <>
          <CvpButton
            label={L.id("29fe24f67c95").loc("Jeg samtykker ikke")}
            icon="pi pi-times"
            severity="danger"
            outlined
            onClick={() => {
              setOpenDeleteDialog(true);
              onConsentDecline();
            }}
          />
          <CvpButton
            label={L.id("24bf3a80b43f").loc("Jeg samtykker")}
            icon="pi pi-check"
            onClick={onConsentAccept}
          />
        </>
      }
      onHide={() => {}}
      closable={false}
    >
      <Consent5000 noBorder />
    </CvpDialog>
  );
};
